// extracted by mini-css-extract-plugin
export default {"backTop":"BackTop_backTop__2Y9t+","show":"BackTop_show__SpnLd","icon":"BackTop_icon__qRbA6"};